import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import ProductImage from "../../../pages/shared/components/product-image";
import CustomTypography from "../typography";
import Benefits from "./benefits";
import WelcomeMilesBubble from "./welcome-miles-bubble";
import { ProductContext } from "../../../context/product-context/productContext";
import { Product } from "../../../context/product-context/product";

const classNameBase = "scd-product-panel";

export default function ProductPanel({
  selectedProduct,
}: {
  selectedProduct: Product;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();
  const { resetProductToDefault } = useContext(ProductContext);

  resetProductToDefault();

  const hasMilesAndMore = selectedProduct?.hasFeature("MILES_AND_MORE");

  return (
    <div className={classNameBase}>
      <CustomTypography variant="h4">
        {getMessage(`${selectedProduct?.translationKey}.title`)}
      </CustomTypography>
      <div className="scd-product-selection-showcase">
        <div className="scd-product-selection-wrapper">
          {hasMilesAndMore && (
            <WelcomeMilesBubble
              label={getMessage(
                "ProductBenefits.loyaltyPrograms.welcome-miles-label",
              )}
              product={selectedProduct?.productRef}
            />
          )}
          <ProductImage product={selectedProduct?.productRef} />
        </div>
        <Benefits selectedProduct={selectedProduct} />
      </div>
    </div>
  );
}
